import { render } from "./LiveBalance.vue?vue&type=template&id=5de028f9&ts=true"
import script from "./LiveBalance.vue?vue&type=script&lang=ts"
export * from "./LiveBalance.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__